/*eslint-disable*/
import api from '../'

class chainsGameItems {
    // POST: chain
    static getChainReadingEnByRequest (params) {
        return api.axios.post('/chainReadingEnByRequest', params).then(response => response.data.chain);
    }
}

export default chainsGameItems;
